/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Fieldset component for text input
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-fieldset-output[_ngcontent-%COMP%]{min-height:125px!important}"];
export { styles as styles };
